import { useId } from 'react';
import './ui.css';

/**
 * 共用文字欄位 chrome：label／hint／error 與 input 正確關聯。
 */
export default function TextField({
  label,
  required = false,
  hint,
  error,
  disabled = false,
  id,
  className = '',
  value,
  onChange,
  placeholder,
  type = 'text',
  name,
  autoComplete,
  ...rest
}) {
  const generatedId = useId();
  const inputId = id || generatedId;
  const hintId = `${inputId}-hint`;
  const errorId = `${inputId}-error`;
  const describedBy = [
    hint ? hintId : null,
    error ? errorId : null,
  ]
    .filter(Boolean)
    .join(' ') || undefined;

  return (
    <div className={`ui-field ${error ? 'ui-field--error' : ''} ${className}`.trim()}>
      {label ? (
        <label className="ui-field__label" htmlFor={inputId}>
          {label}
          {required ? <span className="ui-field__required" aria-hidden="true">*</span> : null}
        </label>
      ) : null}
      <input
        id={inputId}
        className="ui-field__control"
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        autoComplete={autoComplete}
        aria-invalid={error ? true : undefined}
        aria-describedby={describedBy}
        {...rest}
      />
      {hint && !error ? (
        <p id={hintId} className="ui-field__hint">
          {hint}
        </p>
      ) : null}
      {error ? (
        <p id={errorId} className="ui-field__error" role="alert">
          {error}
        </p>
      ) : null}
    </div>
  );
}
